import React from "react";
import ProfileViewPage from "./views/ProfileViewPage";
import { ProfileViewContextProvider } from "./ProfileView";
import ProfileViewContent from "../../constants/contentFile.json";

const ProfileView = () => {
  return (
    <ProfileViewContextProvider>
      <ProfileViewPage textContents={ProfileViewContent.pageProfileView} />
    </ProfileViewContextProvider>
  );
};
export default ProfileView;
